import uploadFileQueryPartial from '@/queries/uploadFileQueryPartial';

export default `
  name
  file {
    ${uploadFileQueryPartial}
  }
  id
`;
